import { Component, Event, EventEmitter, h, Host, Prop } from "@stencil/core";
import {
  AddToWishlistEventDetails,
  AddToWishlistProps,
} from "./bcp-add-to-wishlist-model";
import wishlistStore, {
  addEntryToNewWishlist,
  addEntryToWishlist,
} from "@stores/wishlist.store";
import { ContextService } from "@globals/helpers";

@Component({
  tag: "bcp-add-to-wishlist",
})
export class BcpAddToWishlist {
  @Prop() wishlistLabel: AddToWishlistProps["wishlistLabel"] =
    "Add to wishlist";

  @Prop() modalHeaderLabel: AddToWishlistProps["modalHeaderLabel"];

  @Prop() modalBodyLabel: AddToWishlistProps["modalBodyLabel"];

  @Prop()
  modalAddToNewWishlistLabel: AddToWishlistProps["modalAddToNewWishlistLabel"];

  @Prop() addToWishlistUrl: AddToWishlistProps["addToWishlistUrl"];

  @Prop() productCode: AddToWishlistProps["productCode"];

  @Prop() quantity: AddToWishlistProps["quantity"] = 1;

  @Prop() isMultiCart: AddToWishlistProps["isMultiCart"] = true;

  @Prop() buttonDisabled: AddToWishlistProps["buttonDisabled"] = false;

  @Prop() iconOnly: AddToWishlistProps["iconOnly"] = false;

  @Event() productAddedToWishlist: EventEmitter<AddToWishlistEventDetails>;

  private wishlistSelectModal: HTMLBcpSelectWishlistModalElement = null;

  private handleAddToWishlistButton = async () => {
    if (
      !ContextService.isAnonymous() &&
      this.isMultiCart &&
      wishlistStore.wishlists.length > 0
    ) {
      return await this.wishlistSelectModal.openModal();
    }
    if (wishlistStore.wishlists.length === 0) {
      addEntryToNewWishlist(this.productCode, this.quantity).then(
        (wishlist) => {
          this.productAddedToWishlist.emit({
            productCode: this.productCode,
            wishlistCode: wishlist.code,
          });
        }
      );
    }
    addEntryToWishlist(
      wishlistStore.wishlists[0].code,
      this.productCode,
      this.quantity
    ).then(() => {
      this.productAddedToWishlist.emit({
        productCode: this.productCode,
        wishlistCode: wishlistStore.wishlists[0].code,
      });
    });
  };

  render() {
    return (
      <Host>
        <f-button
          variant="secondary"
          fullWidth={true}
          disabled={this.buttonDisabled}
          iconOnly={this.iconOnly}
          onClick={this.handleAddToWishlistButton}
        >
          <f-icon iconName="wishlist" titleText={this.wishlistLabel} />
          {this.iconOnly ? (
            <f-visually-hidden>{this.wishlistLabel}</f-visually-hidden>
          ) : (
            <span>{this.wishlistLabel}</span>
          )}
        </f-button>
        <bcp-select-wishlist-modal
          ref={(el) => (this.wishlistSelectModal = el)}
          addToWishlistUrl={this.addToWishlistUrl}
          productCode={this.productCode}
          quantity={this.quantity}
          headerLabel={this.modalHeaderLabel}
          bodyLabel={this.modalBodyLabel}
          addToNewWishlistLabel={this.modalAddToNewWishlistLabel}
        />
      </Host>
    );
  }
}
